module.exports = __webpack_public_path__ + "img/doricmor_logo.ae9453e7.jpg";